import _extends from "@babel/runtime/helpers/esm/extends";
export function getSeriesWithDefaultValues(seriesData, seriesIndex, colors) {
  return _extends({}, seriesData, {
    id: seriesData.id ?? `auto-generated-id-${seriesIndex}`,
    color: seriesData.color ?? colors[seriesIndex % colors.length]
  });
}